import { atom } from "recoil";

export const ReviewersState = atom({
  key: "ReviewersState",
  default: [],
})